import callApi from "@repo/next-shared/utils/api";
import {
  SearchProductsResponse,
  SearchProductsQueryParams,
  getGenderFilter,
  GenderItem,
} from "@/types/product-search";
import { useQuery } from "@tanstack/react-query";
import { objToQueryParams, objToArrayKeys } from "@repo/next-shared/utils";

export async function getProductsSearch(
  searchParams?: Partial<SearchProductsQueryParams>,
  locale?: keyof GenderItem,
) {
  if (!searchParams?.pageSize) {
    searchParams = {
      ...searchParams,
      pageSize: 72,
    };
  }

  if (searchParams?.gender) {
    let gender = [...searchParams?.gender];

    if (searchParams?.gender.some((g: any) => g === "man" || g === "woman")) {
      gender = [...searchParams?.gender, "unisex", "not-applicable"];
    }

    searchParams = {
      ...searchParams,
      gender: gender.map((g: any) => getGenderFilter(locale!, g)),
    };
  }

  // if (searchParams?.categoryId) {
  //   return await cacheApiData(redisKeys.CATEGORY_PRODUCTS(Object.values(searchParams).join(":")), {
  //     path: `/catalog/customer/product/search?${objToQueryParams(searchParams)}`,
  //     method: "GET",
  //   })
  // }

  return await callApi<SearchProductsResponse>({
    path: `/catalog/customer/product/search?${objToQueryParams(searchParams)}`,
    method: "GET",
  });
}

export function useProductsSearchBase(
  select: any,
  searchParams?: Partial<SearchProductsQueryParams>,
): any {
  let keys: any[] = [];

  if (searchParams) {
    keys = objToArrayKeys(searchParams);
  }

  return useQuery({
    queryKey: ["products", ...keys],
    queryFn: () => getProductsSearch(searchParams),
    select,
    staleTime: 5000,
  });
}

export function useProductsSearch(
  searchParams: Partial<SearchProductsQueryParams>,
): any {
  return useProductsSearchBase(
    (data: SearchProductsResponse) => data,
    searchParams,
  );
}
